<template>
  <section class="AiCarouselFullWidth-background">
    <article class="Layout">
      <div class="Layout-section">
        <grid-item
          offset-md="1"
          md="8"
          sm="4"
          class="AiCarouselFullWidth-header">
          <ai-typo as="h2" variant="heading-02" aria-level="2">
            {{ title }}
          </ai-typo>
        </grid-item>

        <grid-item
          offset-md="1"
          md="5"
          sm="4"
          class="AiCarouselFullWidth-header">
          <ai-typo
            as="p"
            variant="paragraph-03-regular"
            class="AiCarouselFullWidth-description">
            {{ description }}
          </ai-typo>
        </grid-item>

        <grid-item offset-md="1" md="9" sm="4">
          <div>
            <component
              :is="component"
              v-if="items.length === 1"
              v-bind="items[0].props" />

            <ai-carousel
              v-else
              v-model="step"
              :items="items"
              :access-id="accessId"
              hide-gallery
              :button-position="buttonPosition"
              :mobile-button="mobileButton"
              :gutter="gutter"
              arrows-top-position="15%"
              :slide-width="slideWidth"
              position="right" />
          </div>
        </grid-item>
      </div>
    </article>
  </section>
</template>

<script setup lang="ts">
import AiTypo from '../../atoms/AiTypo/AiTypo.vue';
import type { AiCarouselItem } from '../../molecules/AiCarousel/types';
import AiCarousel from '../../molecules/AiCarousel/AiCarousel.vue';

export interface AiCarouselFullWidthProps {
  accessId: string;
  items: AiCarouselItem[];
  title: string;
  buttonPosition?: 'start' | 'center' | 'end';
  mobileButton?: boolean;
  description: string;
  component: Component;
}

const step = ref<number>(1);
const items = computed<AiCarouselItem[]>(() => {
  return props.items.map(item => {
    return item;
  });
});

const isSmallDevice = useMatchMediaQuery('tablet');
const gutter = computed(() => (isSmallDevice.value ? 16 : 24));
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 1));

const props = withDefaults(defineProps<AiCarouselFullWidthProps>(), {
  description: '',
  items: () => [],
  title: '',
  buttonPosition: 'start',
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.AiCarouselFullWidth-background {
  background-color: colors.$secondary-aqua-blue-100;
  padding-top: constants.$padding-07;
  padding-bottom: constants.$padding-07;
}

.AiCarouselFullWidth-header {
  margin-bottom: constants.$margin-04;

  @media (mq.$from-medium) {
    margin-bottom: constants.$margin-05;
  }
}

.AiCarouselFullWidth-description {
  padding-top: constants.$padding-02;
}
</style>
